import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DownloadModalService {
  private state = new BehaviorSubject<boolean>(false);
  private info = new BehaviorSubject<any>(null);
  private fromCart = new BehaviorSubject<boolean>(false);
  
  isOpen$ = this.state.asObservable();
  info$ = this.info.asObservable();
  fromCart$ = this.fromCart.asObservable();

  open(itemInfo?: any, fromCart: boolean = false): void {
    this.info.next(itemInfo);
    this.fromCart.next(fromCart);
    this.state.next(true);
  }

  close(): void {
    this.state.next(false);
    this.info.next(null);
  }
}

